import { Branding as ApiBranding, PortalSettings as ApiPortalSettings } from '@/generatedTypes'

type Branding = ApiBranding & {
  isQuotesPortal?: boolean
  hasGuestQuotes?: boolean
  isEssentialPortal?: boolean
}

type PortalSettings = ApiPortalSettings & {
  clearBrowserSession?: boolean
  hideColleaguesPermissions?: boolean
  showPaymentMethodSelection?: boolean
  hideProfile?: boolean
  useCollections: boolean
  useOrders: boolean
  minimumOrderSurchargesOnlyApplyOncePerCart: boolean
  platformCartLink?: string
  backToPlatformLink?: string
  useTopi?: boolean
}

type LoginFooter = {
  ownerName: string
  legalInfoUrl?: string
  privacyUrl?: string
  termsUrl?: string
}

type PortalTypeConfig = {
  portalType: PortalType
  hasGuestQuotes: boolean
}

enum PortalType {
  QUOTES_PORTAL = 'QUOTES_PORTAL',
  DEFAULT_PORTAL = 'DEFAULT_PORTAL',
  PORTAL_UNAVAILABLE = 'PORTAL_UNAVAILABLE'
}

export { Branding, LoginFooter, PortalSettings, PortalType, PortalTypeConfig }
